<div class="container rating-wrapper" style="--rating: {{ rating.toFixed(1) }}" [ngStyle]="{ 'flex-flow': flow }">
  <div class="rating-container">
    <div class="rating" [style.width.%]="rating * 20"></div>
    <div class="empty"></div>
  </div>
  <div class="review-container">
    @if (!starOnly) {
      <span class="reviews">
        {{ rating.toFixed(1) }} | {{ reviews }} Reviews
      </span>
    }
  </div>
</div>
